module.exports = __webpack_public_path__ + "img/bateria.84460831.svg";